// extracted by mini-css-extract-plugin
export default {"inputWrapper":"ChatSearch_inputWrapper__4KDxk","sendIcon":"ChatSearch_sendIcon__THIzd"};